import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";

import style from "./style";
import { CheckBox, DescriptionField } from "components/support";

class CompanyIntegrationsMercadoPagoView extends Component {
  render() {
    const { className, company } = this.props;
    const integrations = company.integrations || {};
    const mercado_pago = integrations.mercado_pago || {};
    const { token, enabled } = mercado_pago || {};

    return (
      <div className={`${className} grid-container`}>
        <Row>
          <Col xs={12}>
            <div className="grid-container mt-sm mb-sm">
              <Typography type="headline">Mercado Pago</Typography>
              <hr />
              <Row bottom="xs">
                <Col xs={12}>
                  <div className="integration-status">
                    <CheckBox
                      checked={enabled}
                      style={{ paddingLeft: 4 }}
                      label="Status Integração"
                      disabled
                    />
                    <div className="tooltip">
                      <Tooltip
                        key="tooltip-top-mercado-pago"
                        title="Edite a empresa para ativar/desativar a integração com o Mercado Pago"
                        placement="top"
                      >
                        <Icon className="tooltip-icon">info</Icon>
                      </Tooltip>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <DescriptionField
                    label="Token do Mercado Pago"
                    value={token}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default style(CompanyIntegrationsMercadoPagoView);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/integrations/mercado-pago/index.js